import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';
import { ReverseAuctionResource } from 'app/_resources/reverse-auction.resource';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { ReverseAuctionUploadWizardService } from 'app/_services/reverse-auction-upload-wizard.service';
import { UtilService } from 'app/_services/util.service';

interface ReverseProductUploadContextUiData extends ReverseAuctionUploadDto {
    uploadSuccessful?: boolean;
    successMessage?: string;
    successDetails?: string;
    errorMessage?: string;
    errorDetails?: string[];
    selectedNetworkPoint?: NetworkPointDto;
    wizardGuid: string;
    bundled: boolean;
    networkPoint: any;
}

export interface ReverseProductUploadContext {
    data: ReverseProductUploadContextUiData;
    transferData: ReverseProductUploadContextUiData[];
    createWizardRunBaseData: () => ReverseProductUploadContextUiData;
    competition: PriceUnitDto;
}

class UploadWizardComponentCtrl implements ng.IController {
    public readonly WIZARD_NAME = 'Reverse auction upload';
    public wizard: mgoAngularWizard.Wizard<ReverseProductUploadContext>;
    private authenticatedUser: LoginResult;
    private isReverseAuctionConfigSupported: boolean;
    public loading: boolean = false;
    public loadingError: boolean = false;

    constructor(
        private WizardHandler: mgoAngularWizard.WizardHandler<ReverseProductUploadContext>,
        private reverseAuctionUploadWizardService: ReverseAuctionUploadWizardService,
        private utilService: UtilService,
        private reverseAuctionResource: ReverseAuctionResource,
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private authService: AuthService,
        private errorHandler: ErrorHandler
    ) {}

    $onInit(): void {
        this.loading = true;
        this.authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                this.authenticatedUser = loginResult;
                this.TransmissionSystemOperator.isRAConfigurationSupported(
                    { id: this.authenticatedUser.referenceId },
                    (res: boolean) => {
                        this.loading = false;
                        this.isReverseAuctionConfigSupported = res;
                    },
                    (err) => {
                        this.handleError(err);
                    }
                );
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    handleError(err) {
        this.loadingError = true;
        this.loading = false;
        this.errorHandler(err);
    }

    $doCheck(): void {
        if (this.wizard) {
            return;
        }

        let wizard: mgoAngularWizard.Wizard<ReverseProductUploadContext> =
            this.WizardHandler.wizard(this.WIZARD_NAME);

        if (wizard) {
            this.wizard = wizard;

            Object.keys(this.wizard.context).forEach(
                (key) => delete this.wizard.context[key]
            );
            this.wizard.context.createWizardRunBaseData = () => {
                return <any>{
                    errorDetails: [],
                    wizardGuid: this.utilService.generateGuid()
                };
            };
            this.wizard.context.data =
                this.wizard.context.createWizardRunBaseData();
            this.wizard.context.transferData = [];
        }
    }

    public finish() {
        var mappedData = this.reverseAuctionUploadWizardService.getMappedData({
            transferData: this.wizard.context.transferData,
            competition: this.wizard.context.competition
        });

        return this.reverseAuctionResource.save(
            mappedData,
            (res) => {
                this.wizard.context.data.uploadSuccessful = true;
                this.wizard.context.data.successMessage =
                    'The product upload succeeded.';
                this.wizard.context.data.successDetails = res.responseXml;
            },
            (error) => {
                if (!!error.data.message) {
                    var errorMsg = error.data.message;
                    if (~errorMsg.indexOf('ValidationError|')) {
                        this.wizard.context.data.errorMessage =
                            'The validation of the uploaded product data failed!';
                        this.wizard.context.data.errorDetails =
                            errorMsg.split('|');
                        this.wizard.context.data.errorDetails.splice(0, 1);
                    } else {
                        this.wizard.context.data.errorMessage =
                            'The product upload failed!';
                        this.wizard.context.data.errorDetails.push(errorMsg);
                    }
                }
            }
        ).$promise;
    }
}

angular.module('app').component('pkpReverseAuctionUploadWizard', {
    controller: UploadWizardComponentCtrl,
    template:
        require('app/reverse-auction-upload-wizard/reverse-auction-upload-wizard.component.html'),
    bindings: {}
});
